const regexPattern = (pattern, message) => value => {
  const regex = new RegExp(pattern, "gi");
  return  !value ? undefined : !regex.test(value) ? message : undefined
  return undefined;
}

export default regexPattern;